import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicThreeIntervals extends DesigntimeComponent {
    static staticName = "Logic: Three intervals";
    static staticId = "logicThreeIntervals";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            limit1: { value: 5 },
            limit2: { value: 10 }
        };

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $(`<div class='${this.type}'></div>`);
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (eventParams.key == this.params.parameter1.key)
            this.params.parameter1.value = parseInt(eventParams.value);
        else
            return;

        var input = this.params.parameter1.value;
        var l1 = this.values.limit1.value;
        var l2 = this.values.limit2.value;

        var res = 3;
        if (input < l2) {
            res = 2;
        }
        if (input < l1) {
            res = 1;
        }

        this.eventBroker.fireValueChanged(this.id, "value", res);
        this.eventBroker.fireValueChanged(this.id, "intervall_1", res == 1);
        this.eventBroker.fireValueChanged(this.id, "intervall_2", res == 2);
        this.eventBroker.fireValueChanged(this.id, "intervall_3", res == 3);

    }

    output = [
        { name: "value", type: "int" },
        { name: "intervall_1", type: "bool" },
        { name: "intervall_2", type: "bool" },
        { name: "intervall_3", type: "bool" }
    ];
}

export { LogicThreeIntervals }
